import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const LoadingScreen = () => (
    <div className="min-h-screen bg-[#FBFBF9] flex items-center justify-center">
        <div className="text-center">
            <div className="w-16 h-16 bg-[#425A65] rounded-2xl flex items-center justify-center mx-auto mb-4 animate-pulse">
                <span className="text-white text-2xl font-bold font-['Outfit']">S</span>
            </div>
            <p className="text-[#616E7C]">Cargando...</p>
        </div>
    </div>
);

export const ProtectedRoute = ({ children, requireRole }) => {
    const { user, loading, isAuthenticated, mustChangePassword } = useAuth();

    if (loading) {
        return <LoadingScreen />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Force password change
    if (mustChangePassword) {
        return <Navigate to="/cambiar-password" replace />;
    }

    // Check role if required
    if (requireRole && user?.role !== requireRole) {
        // Redirect to appropriate dashboard
        if (user?.role === 'mentor') {
            return <Navigate to="/mentor" replace />;
        }
        return <Navigate to="/usuario" replace />;
    }

    return children;
};

export const PublicRoute = ({ children }) => {
    const { user, loading, isAuthenticated, mustChangePassword } = useAuth();

    if (loading) {
        return <LoadingScreen />;
    }

    if (isAuthenticated) {
        if (mustChangePassword) {
            return <Navigate to="/cambiar-password" replace />;
        }
        if (user?.role === 'mentor') {
            return <Navigate to="/mentor" replace />;
        }
        return <Navigate to="/usuario" replace />;
    }

    return children;
};

export const PasswordChangeRoute = ({ children }) => {
    const { loading, isAuthenticated, mustChangePassword } = useAuth();

    if (loading) {
        return <LoadingScreen />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!mustChangePassword) {
        return <Navigate to="/usuario" replace />;
    }

    return children;
};
